import { SortingCriteria } from '@cinch-nx/data-search'
import { BaseComponent } from '@cinch-nx/data-storyblok'
import { CarsCarousel as SharedCarsCarousel } from '@cinch-nx/shared-cars-carousel'
import style from './cars-carousel.module.css'

export interface CarsCarouselProps extends BaseComponent {
  component: 'CarsCarousel'
  title?: string
  sortBy?: string
  showOnlyCinchStock?: boolean
  priceFrom?: number
  priceTo?: number
  carsCondition?: 'new' | 'used'
  disclaimer?: string
  showBrowseAllCarsCard?: boolean
}

export function CarsCarousel({
  title,
  sortBy,
  showOnlyCinchStock,
  priceFrom,
  priceTo,
  carsCondition,
  disclaimer,
  showBrowseAllCarsCard,
}: CarsCarouselProps) {
  return (
    <div className={style.container}>
      <SharedCarsCarousel
        title={title}
        sortBy={mapSortingCriteria(sortBy)}
        showOnlyCinchStock={showOnlyCinchStock}
        priceFrom={priceFrom}
        priceTo={priceTo}
        carsCondition={carsCondition}
        disclaimer={disclaimer}
        showBrowseAllCarsCard={showBrowseAllCarsCard}
      />
    </div>
  )
}

const mapSortingCriteria = (
  sortBy: string | undefined,
): SortingCriteria | undefined => {
  switch (sortBy) {
    case 'FIRST_PUBLISHED_DATE_ASC': {
      return SortingCriteria.FIRST_PUBLISHED_DATE_ASC
    }
    case 'FIRST_PUBLISHED_DATE_DESC': {
      return SortingCriteria.FIRST_PUBLISHED_DATE_DESC
    }
    case 'MILEAGE_ASC': {
      return SortingCriteria.MILEAGE_ASC
    }
    case 'MILEAGE_DESC': {
      return SortingCriteria.MILEAGE_DESC
    }
    case 'AGE_ASC': {
      return SortingCriteria.AGE_ASC
    }
    case 'AGE_DESC': {
      return SortingCriteria.AGE_DESC
    }
    case 'MONTHLY_PRICE_ASC': {
      return SortingCriteria.MONTHLY_PRICE_ASC
    }
    case 'MONTHLY_PRICE_DESC': {
      return SortingCriteria.MONTHLY_PRICE_DESC
    }
    case 'FULL_PRICE_ASC': {
      return SortingCriteria.FULL_PRICE_ASC
    }
    case 'FULL_PRICE_DESC': {
      return SortingCriteria.FULL_PRICE_DESC
    }
    case 'DATA_DRIVEN_SORT': {
      return SortingCriteria.DATA_DRIVEN_SORT
    }
    default: {
      return undefined
    }
  }
}
